import HostRequestsIndex from './HostRequestsIndex';
import HostRequestsCreate from './HostRequestsCreate';
import HostRequestsSettings from './HostRequestsSettings';
import HostRequestsSingle from './HostRequestsSingle';

export default function (app) {

    const settings = HostRequestsSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Pending",
                path: settings.path + "/status/pending",
                caps: settings.indexCaps
            },
            {
                label: "Resolved",
                path: settings.path + "/status/resolved",
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            }
        ],
    });

    HostRequestsIndex(app, settings);

    HostRequestsCreate(app, settings);

    HostRequestsSingle(app, settings);

}